module.exports = __webpack_public_path__ + "img/jh.07b7c3ad.webp";